export enum FileLineLocInfoTypes {
    Response = 'response',
    Request = 'request',
}